$(document).foundation();

jQuery(document).ready(function($) {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // Font size switcher
  $('.font-sizes').on('click', 'a', function(e) {
    e.preventDefault();
    var $link = $(this),
        size = parseInt($link.text());

    // Set active class
    $link.addClass('active').siblings().removeClass('active');

    // Remove html class that start with font-size-
    $('html').removeClass(function(_, className) {
      return (className.match(/\bfont-size-\S+/g) || []).join(' ');
    }).addClass('font-size-' + size);

    // Save into cookie
    window.Cookies.set('font-size', size);
  });

  // Toc toggle
  $('.page-toc-wrapper__button').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.page-toc-wrapper').toggleClass('active');
  });

  // Keyboard event for TOC item
  $('.toc-list a').on('keydown', function(e) {
    var $el = $(this),
        $item = $el.parent('li');

    switch (e.key) {
      case 'ArrowUp':
        var $prev = $item.prev()
        if ($prev.length > 0) {
            $prev.children('a').get(0).focus()
        }
        e.preventDefault()
        break;

      case 'ArrowDown':
        var $next = $item.next()
        if ($next.length > 0) {
            $next.children('a').get(0).focus()
        }
        e.preventDefault()
        break;

      case 'Escape':
        $('.page-toc-wrapper').removeClass('active')
        $('.page-toc-wrapper__button').get(0).focus()
        e.preventDefault()
        break;
    }
  });

  // On scroll event, show or hide the back to top button
  var $backToTop = $('.back-to-top')
  $(window).on('scroll', function(e) {
    if ($(this).scrollTop() > 300) {
      $backToTop.addClass('active').attr('tabindex', 0);
    } else {
      $backToTop.removeClass('active').attr('tabindex', -1);
    }
  });

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
